import script from "./YingBiItems.vue?vue&type=script&setup=true&lang=js"
export * from "./YingBiItems.vue?vue&type=script&setup=true&lang=js"

import "./YingBiItems.vue?vue&type=style&index=0&id=cfbceb76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfbceb76"]])

export default __exports__